import { MapPin } from "@phosphor-icons/react";
import { field, LocationMap } from "./booking-shared";

/* ---------- Step 1: Address & property ---------- */
export function StepAddress({ query, onQuery, sugg, selectAddress, busy, parcel, o, pickType, inService }) {
  return (
    <div data-testid="step-address">
      <h2 className="font-display text-2xl text-[#4A0000]">Where are we shooting?</h2>
      <p className="text-sm text-[#5C5A58] mt-1 mb-4">Type the address — we'll price it instantly.</p>
      <div className="relative">
        <MapPin size={17} weight="fill" className="absolute left-3 top-1/2 -translate-y-1/2 text-[#B08D57]" />
        <input className={`${field} pl-9`} data-testid="address-input" placeholder="Start typing an address…" value={query} onChange={(e) => onQuery(e.target.value)} autoFocus />
        {sugg.length > 0 && (
          <div className="absolute z-20 left-0 right-0 mt-1 bg-white border border-[#E9DDC6] rounded-lg shadow-[0_8px_30px_rgba(26,23,21,0.12)] overflow-hidden" data-testid="address-suggestions">
            {sugg.slice(0, 6).map((s, i) => (
              <button key={i} className="block w-full text-left px-3 py-2.5 text-sm hover:bg-[#FAF9F6] transition-colors" data-testid={`address-sugg-${i}`} onClick={() => selectAddress(s)}>
                {s.label || s.display}
              </button>
            ))}
          </div>
        )}
      </div>
      {busy && <p className="text-sm text-[#5C5A58] mt-4">Locating on the map…</p>}

      {o.address && !busy && (
        <div className="mt-5 space-y-3">
          {(o.lat != null && o.lon != null) && (
            <LocationMap lat={parcel?.lat ?? o.lat} lon={parcel?.lon ?? o.lon} label={o.address} />
          )}
          {!inService && (
            <div className="rounded-lg bg-[#B4472E]/8 border border-[#B4472E]/30 p-3 text-sm text-[#8a2f1c]" data-testid="out-of-area">
              We're not in {o.state} yet — continue and we'll save your details & reach out, or call us below.
            </div>
          )}
          <p className="text-[11px] text-[#8A8782] flex items-center gap-1.5">
            <MapPin size={12} weight="fill" className="text-[#B08D57]" />That's the spot? Continue to choose your package.
          </p>
        </div>
      )}
    </div>
  );
}
